import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import { api, titles } from '../data';

import LoadingAnimation from './modules/LoadingAnimation';
import Title from './modules/Title';

class Item extends Component {
  render() {

    const item = this.props.item;
    const content = item.content.rendered.replace(/(<([^>]+)>)/ig,"").substr(0, 70) + '...';

    const noImgClass = item.featured_image === null ? 'no-img' : '';

    return (
      <article className="news__item">
        <Link to={`/news/${item.slug}`}>
          <time className="news__item__date">{item.modified.split('T')[0].replace(/-/g, '/')}</time>
          <figure className={`news__item__img ${noImgClass}`} style={{'backgroundImage': `url(${item.featured_image})`}} />
          <Title header="h3" title={item.title.rendered} />
          <div className="news__item__desc">{content}</div>
          <button className="read-more-btn">続きを読む</button>
        </Link>
      </article>
    )
  }
}

class NewsList extends Component {

  constructor(props) {
    super(props);
    this.pageNum = 1;
    this.posts = [];
    this.splitedPosts = [];
    this.isNoMore = false;
  }

  updatePosts() {
    this.pageNum += 1;
    return this.props.updateStatus(this.pageNum);
  }

  render() {
    const posts = this.props.posts;
    const { updateStatusResponse } = this.props;

    if(!updateStatusResponse) {
      this.posts = posts;
      if(this.posts.length < 10) this.isNoMore = true;
    }

    if(typeof updateStatusResponse !== 'undefined' && updateStatusResponse.value !== null) {
      this.posts = this.posts.concat(updateStatusResponse.value);

      if (updateStatusResponse.value.length < 10) {
        this.isNoMore = true;
      } else {
        this.isNoMore = false;
      }
    }

    let splitedPosts = []

    for(let i = 0; i < this.posts.length; i+=2) {
      splitedPosts.push( this.posts.slice(i, i+2) );
    }

    return (
      <div>
        <Helmet title={titles.news} titleTemplate={titles.titleTemplate} />
        <section className="news">
          <Title header="h1" title="お知らせ" />
          {splitedPosts
            ?
              <div>
                <div className="news__list">
                  { splitedPosts.map((items, index) => {
                    return (
                      <div className="clear-line" key={`clear-line-${index}`}>
                        {items.map(item => <Item item={item} key={item.id} /> )}
                      </div>
                    )
                  })}
                </div>
                { !this.isNoMore ? <button className="load-more-btn" onClick={() => this.updatePosts()}>もっとみる</button> : '' }
              </div>
            : ''
          }
        </section>
      </div>
    )
  }
}

class NewsFetch extends Component {

  render() {

    const { postsFetch } = this.props;

    const allFetches = PromiseState.all([postsFetch]);

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [posts] = allFetches.value;

      return (
        <div>
          <NewsList {...this.props} posts={posts} />
        </div>
      )
    }
  }
}

export default connect(() => {

  return {
    postsFetch: `${api.base_url}/posts?filter[posts_per_page]=${api.posts_per_page}`,

    updateStatus: status => ({
      updateStatusResponse: {
        url: `${api.base_url}/posts?filter[posts_per_page]=${api.posts_per_page}&page=${status}`,
        method: 'GET'
      }
    })
  }
})(NewsFetch);



/** WEBPACK FOOTER **
 ** ./src/components/NewsList.js
 **/